<template>
    <div class="update-secrect" v-bind:style="{'min-height': myHeight}">
        <header-comp></header-comp>
        <div class="update-secrect-wrap">
            <img src="@/assets/img/pages/registerFlow/lock.svg" alt="">
            <h1 v-if="$route.query.mode == 'reset'">密碼更新成功</h1>
            <h1 v-else>密碼設定成功</h1>
            <router-link :to="{ name: 'bizLogin'}">
                <div class="default-button">去登入</div>
            </router-link>
        </div>
        <!-- <footer-comp></footer-comp> -->
    </div>
</template>
<script>
import Header from '@/components/bussiness/header.vue';
import Footer from '@/components/Footer.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            myHeight: window.innerHeight + 'px',
        }
    },
    components: {
        'header-comp': Header,
        'footer-comp': Footer
    }
}
</script>
<style lang="scss" scoped>
    .update-secrect{
        position: relative;
        background: #F6F6F6;
        >.update-secrect-wrap{
            position: relative;
            border-radius: 6px;
            top: 125px;
            width: 294px;
            background: #FFF;
            margin: 0 auto;
            margin-bottom: 208px;
            padding: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img{
                margin-top: 20px;
                margin-bottom: 20px;
            }
            h1{
                font-size: 24px;
                margin-bottom: 40px;
            }
            >a{
                width: 100%;
                .default-button{
                    margin-top: 6px;
                    width: 100%;
                    padding: 14px 0 14px 0;
                }
            }
            
        }
    }
    @media screen and (max-width: 375px) {
        .update-secrect{
            position: relative;
            >.update-secrect-wrap{
                width: 254px;
            }
        }
    }
    @media screen and (max-width: 320px) {
        .update-secrect{
            position: relative;
            >.update-secrect-wrap{
                width: 224px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/registerFlow/updateSecrectSuccess.vue